/** Base path of the ai-auth REST API on the api-gateway. */
export const AUTH_BASE = '/auth/api/v1/auth';

/** Per-tenant module configuration endpoint (`GET`/`PUT`/`PATCH`). */
export const moduleConfigPath = (clientId: string) => `${AUTH_BASE}/clients/${clientId}/module-config`;
